/**
* @ngdoc service
* @name common.service:ItxStaticResourceSvc
* @description
* Static resource service.
* This service will responsible to centralize the resource paths. The main goal is to have a unique place
* where to manage directory names and be easy to change if needed.
*/
(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('ItxStaticResourceSvc', ItxStaticResourceSvc);
    
    ItxStaticResourceSvc.$inject = [
        'timestampSvc',
        'logger',
        '$q'
    ];
    
    function ItxStaticResourceSvc (
        timestampSvc,
        logger,
        $q
    ) {

        var _this = this;
        
        _this.static = inditex.iStaticContentUrl;
        
        _this.path={};
        
        _this.webStandard =_this.static + '/itxwebstandard/'; 
        
        _this.path.images = _this.webStandard + '/images/';
        _this.path.icons =  _this.webStandard + '/icons/';
        _this.path.payments = _this.static + '/itxstandard/images/payment/';

        _this.path.media = _this.static + '/media';
        var service =  {
            getStatic: getStatic,
            getDomain: getDomain,
            getImage: getImage,
            getIcon: getIcon,
            getPaymentLogo: getPaymentLogo,
            getMapImage: getMapImage,
            getPaymentImage: getPaymentImage,
            getMedia: getMedia,
            getWebStandardPath: getWebStandardPath,
            getCookiePolicyPath: getCookiePolicyPath,
            getAffinityCardPath: getAffinityCardPath,
            getAccesibilitystatement: getAccesibilitystatement,
            getStoreImageUrl: getStoreImageUrl
        }; 
         
        return service;
        
        /**
         * @ngdoc method
         * @name getDomain
         * @methodOf common.service:ItxStaticResourceSvc 
         * @description
         * Get domain resource.
         * @returns {string} static path without param static2
        */
        function getDomain() {
            return _this.domain;
        }


        function getMedia(){
            return _this.path.media;
        }

        /**
         * @ngdoc method
         * @name getImage
         * @methodOf common.service:ItxStaticResourceSvc
         * @description
         * Get image resource.
         * @param {string} image - Image file name
         * @returns {string} image - Image full path
        */
        function getImage(image, timestamp){
            if(timestamp){
                return _this.path.images + image + '?t='+ timestampSvc.getTs();
            }
            
            return _this.path.images + image;
        }

        /**
         * @description
         * Get image resource for new ticketless endpoint (store orders) 
         * @param {*} ticketReference 
         */
        function getStoreImageUrl(ticketReference) {
            var deferred = $q.defer();

            inditex.execute({
                actions: [
                    {
                        action: 'ticketless:article',
                        params: {
                            storeId: inditex.iStoreId,
                            sku: ticketReference.slice(0, -2),
                            size: 2,
                            languageCode: inditex.iLangId,
                            productType: 0
                        }
                    }
                ],
                onFinish: function () {
                    var status = arguments[0];
                    var results = [];
                    for (var i = 1; i < arguments.length; i++) {
                        results.push(arguments[i]);
                    }
                    if (status === 0) {
                        deferred.reject(error);
                    } else {
                        var storeImageUrl = `${results[0].ImageURL}_5_1_16.jpg?t=${timestampSvc.getTs()}`;
                        deferred.resolve(storeImageUrl);
                    }
                }
            });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name getStatic
         * @methodOf  common.service:ItxStaticResourceSvc 
         * @description
         * Get static path
         * @returns {string} static - Static path
        */
        function getStatic(){
            return _this.static;
        }


        /**
         * @name getIcon
         * @methodOf  common.service:ItxStaticResourceSvc 
         * @description
         * Get icon resource.
         * @param {string} icon - Icon file name
         * @returns {string} Icon path 
        */
        function getIcon(icon){
            return _this.path.icons + icon + '?t='+ timestampSvc.getTs();
        }
        /**
         * @name getPaymentLogo
         * @methodOf  common.service:ItxStaticResourceSvc 
         * @description
         * Get payment icon
         * @param {object} method - Payment method object
         * @returns {string} Icon path 
        */
        function getPaymentLogo(method){
            if(!method){
                return null;
            }
            
            var url = inditex.getPaymentMethodImageUrl(method, 'png');
            
            //TODO Remove test urls
            url = url.replace('staticPruStg', 'statici');
            url = url.replace('itxwebstandard', 'itxstandard');
            url = url.replace('.png', '_activo.png');
            
            if (method.kind === joyr.constants.paymentMethods.KACCOUNT || method.kind === joyr.constants.paymentMethods.KINVOICE) {
                url = url.replace('.png', '_' + inditex.iCountryCode + '.png');
            }

            return url;
        }
        /**
         * @name getMapImage
         * @methodOf  common.service:ItxStaticResourceSvc 
         * @description
         * Get map icon based in country and lang. Used in the tunnel to show under the shipping methods.
         * @returns {string} Map image path 
        */
        function getMapImage(){
            return _this.path.images + 'tunel_map/map' + inditex.iLangId + '-' + inditex.iStoreId + '.png?t='+ timestampSvc.getTs();
        }

        /**
        * @ngdoc method
        * @name getPaymentImage
        * @methodOf common.service:ItxStaticResourceSvc 
        * @description
        * Return the payment image.
        * @param {string} fileName image file name 
        * @returns {string} payment image path
        */
        function getPaymentImage(fileName){
            return _this.path.payments + fileName;
        }

        function getWebStandardPath(){
            if(document.location.hostname === 'localhost'){
                return '/static/mainDomain/itxwebstandard/';
            }
            else{
                return '/static/itxwebstandard/';
            }          
        }

        /**
        * @ngdoc method
        * @name getCookiePolicyPath
        * @methodOf common.service:ItxStaticResourceSvc
        * @description
        * Returns the cookies policy pdf for current country and language.
        * @returns {string} file path
        */
        function getCookiePolicyPath(){
            return _this.webStandard 
            + 'pdf/cookie_policy/langId/cookie_policy'
            + inditex.iLangId 
            + '.pdf?'
            + timestampSvc.getTs();
        }

        function getAffinityCardPath(resourceName){
            return _this.webStandard 
            + 'images/affinityCard/' 
            + inditex.iCountryCode 
            + '/'
            + resourceName 
            + '.png?'
            + timestampSvc.getTs();
        }

        function getAccesibilitystatement(){
            return _this.webStandard 
            + 'pdf/accessibilitystatement/accessibilitystatement_october_2019.pdf?'
            + timestampSvc.getTs();
        }


        
    }
        
})();